import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "triggerId", "disabled", "disableToggleClose", "captureOptions", "data", "elRef"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file withContextMenuTrigger
 * @author Yu Zong(liuxuanzy@qq.com)
 */
import React from 'react';
import { useContextMenuTrigger } from '@tencent/glue-react-popper';
import { useCombineRef } from '@tencent/glue-react-use'; // eslint-disable-next-line max-len

export function withContextMenuTrigger(Component) {
  var RenderComponent = Component;

  function ContextMenuTrigger(props) {
    var children = props.children,
        triggerId = props.triggerId,
        disabled = props.disabled,
        disableToggleClose = props.disableToggleClose,
        captureOptions = props.captureOptions,
        data = props.data,
        elRef = props.elRef,
        extra = _objectWithoutProperties(props, _excluded);

    var _useContextMenuTrigge = useContextMenuTrigger({
      disabled: disabled,
      data: data,
      disableToggleClose: disableToggleClose
    }, captureOptions, triggerId),
        _useContextMenuTrigge2 = _slicedToArray(_useContextMenuTrigge, 1),
        triggerRef = _useContextMenuTrigge2[0];

    var ref = useCombineRef(triggerRef, elRef);
    return React.createElement(RenderComponent, _objectSpread(_objectSpread({}, extra), {}, {
      elRef: ref
    }), children);
  }

  return ContextMenuTrigger;
}